
import { Component } from '@angular/core';
import { ShowRequest } from '../../core';
import { TmoLocationLogRecord } from '../../core/models/tmo-location-log-record';
import { DefaultCellRendererComponent, numberToFilterString, TableViewQueryCriteria } from '../../shared/components/table-view/table-view-component-base';


@Component({
    selector: '[fes-tmo-loc-logs-table-cell-renderer]',
    templateUrl: 'tmo-location-logs-table-cell.component.html',
    styleUrls: []
  })
  export class TmoLocationLogsTableCellComponent extends DefaultCellRendererComponent<TmoLocationLogRecord> {

    showLocationTable(record:TmoLocationLogRecord){
      const firstPageCriteria : TableViewQueryCriteria = { 
        page: { 
          firstRowFilters: [
            { key: 'sourceid', mode: '=', value: numberToFilterString(record.id)},
            //{ key: 'locationtime', mode: '=', value: record.ascertained},
          ]
        }
      }
      const strPageSearch = JSON.stringify(firstPageCriteria)
      this.showRequestEmitter.emit( new ShowRequest('tab', 'location logs', strPageSearch, null))
    }

    showCorrelation(record:TmoLocationLogRecord){
      const firstPageCriteria : TableViewQueryCriteria = { 
        page: { 
          firstRowFilters: [
            { key: 'locsourceid', mode: '=', value: numberToFilterString(record.id)},
            //{ key: 'locationtime', mode: '=', value: record.ascertained},
          ]
        }
      }
      const strPageSearch = JSON.stringify(firstPageCriteria)
      this.showRequestEmitter.emit( new ShowRequest('tab', 'correlation', strPageSearch, null))
    }

  }